export default __webpack_public_path__ + "static/media/login.fedc8712.svg";